
import axios from 'axios';

// priorité à la variable d'env
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://tsenanytantsaha.mg/backend'
    : 'http://localhost:5000');

const withApiPrefix = (url) =>
  url.startsWith('/api') || url.startsWith('http') ? url : `/api${url}`;

const api = axios.create({
  baseURL: BASE_URL,
});

export const get  = (url, config)       => api.get(withApiPrefix(url), config);
export const post = (url, data, config) => api.post(withApiPrefix(url), data, config);
// export const put  = (url, data, config) => api.put(withApiPrefix(url), data, config);
export const put  = (url, data, config) => api.put(withApiPrefix(url), data, config);

export const del  = (url, config)       => api.delete(withApiPrefix(url), config);

export const getWelcomeMessage = async () => {
  const res = await get('/test');
  return res.data?.message;
};

export const asset = (path) => {
  if (!path) return '';
  return `${BASE_URL}${path}`;
};

export default api;
